import React, { useEffect } from 'react';
import RecurrenceForm from "./RecurrenceForm";
import FormRow from "../../HorizontalForm/FormRow";
import OccurrenceManagementInput from "./OccurrenceManagement/OccurrenceManagementInput";
import { recurrencePrototype, useRecurrenceManagementForm } from "./RecurrenceManagementFormProvider";

/**
 * A form which allows the user to set recurrence rules for a booking,
 * and then reschedule any occurrences which are invalid.
 * @returns {JSX.Element|null}
 * @constructor
 */
const RecurrenceManagementForm = () => {

    const {
        booking,
        bookingConfig,
        recurrence,
        recurrenceErrors,
        onRecurrenceChange,
    } = useRecurrenceManagementForm();

    if (!recurrence) {
        return null;
    }

    return (<>
        <RecurrenceForm
            recurrence={recurrence}
            onRecurrenceChange={onRecurrenceChange}
            allowDateTimeChange={false}
            fixedTimeslot={{start: booking.start, end: booking.end}}
            maxEndDate={bookingConfig.max_advance_date}
            errors={recurrenceErrors}
            useOnBlurUpdates
        />

        <FormRow label="Occurrences">
            <OccurrenceManagementInput/>
        </FormRow>
    </>);
};

RecurrenceManagementForm.propTypes = {};

RecurrenceManagementForm.defaultProps = {};

export default RecurrenceManagementForm;
